import { Dropdown } from "react-bootstrap";
import { Link, } from "react-router-dom";

// import '../../pages/ItemPage.css'
import { accountService } from "../../services/accountService";
import { useEffect, useState } from "react";
import { GetWalletVariantListAtom, SetWalletVariantListAtom } from "../../store/variantAtom";
import RestartAlt from "@mui/icons-material/RestartAlt";
import Tooltip from "@mui/material/Tooltip";
import TextField from '@mui/material/TextField';
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import {  useLocation, useNavigate } from "react-router-dom";


const columns = [
  {
    title: 'Ref',
    key: 'Customer_Id',
    dataIndex: 'Customer_Id',
  className: "text-primary",
  sorter: (a, b) => (a?.Customer_Id ?? '') - (b?.Customer_Id ?? '')
  },

  {
    title: 'Customer',
    // key: 'id',
    dataIndex: 'Customer_Full_Name',
  className: "text-primary font-bold",
  sorter: (a, b) => (a?.Customer_Full_Name ?? '').localeCompare(b?.Customer_Full_Name ?? '')

  },
    
  {
    title: "GateWay Name",
    dataIndex: "Payment_Gateway_Name",
    sorter: (a, b) => (a?.Payment_Gateway_Name ?? '').localeCompare(b?.Payment_Gateway_Name ?? '')

  },

  {
    title: "Zoho Balance",
    dataIndex: "Zoho_Wallet_Balance",
  sorter: (a, b) => (a?.Zoho_Wallet_Balance ?? '') - (b?.Zoho_Wallet_Balance ?? ''),
  render: (record) => <span> {formatCustomNumber(record)} </span>
  },

  {
    title: "Grocedy Balance",
    dataIndex: "Grocedy_Wallet_Balance",
  sorter: (a, b) => (a?.Grocedy_Wallet_Balance ?? '') - (b?.Grocedy_Wallet_Balance ?? ''),
  render: (record) => <span> {formatCustomNumber(record)} </span>
  },
  {
    title: "Balance Difference",
    dataIndex: "Difference_Balance",
  sorter: (a, b) => (a?.Difference_Balance ?? '') - (b?.Difference_Balance ?? ''),
  render: (record) => <span> {formatCustomNumber(record)} </span>
  },

  {
    title: "Last Updated",
    dataIndex: "Updated_Date",
    sorter: (a, b) => (a?.Updated_Date ?? '').localeCompare(b?.Updated_Date ?? '')

  },

];


function WalletCheckPage() {

      const navigate = useNavigate();
    const { pathname } = useLocation();  
    var url = pathname.split('/')
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];
    
    const getWalletAtom = GetWalletVariantListAtom();
    const setWalletAtomList = SetWalletVariantListAtom();
    const [userList, setUserList] = useState([]);



    useEffect(() => {

        if (!getWalletAtom.wallet_info.length) {
            reloadData();
        } else {
            setUserList(getWalletAtom.wallet_info);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getWalletAtom.wallet_info]);



    const reloadData = () => {
        accountService.getPaymentVariate().then(response => {
            if (response?.data?.wallet_info?.length) {
                setWalletAtomList(response.data);
            }
        }).catch(err => {
            console.log('error ', err);
        })
    }


    const onSearchKeyChange = (eve)=> {
        const search =  eve.target.value;
        if(search.length > 2){
            let tempResult =  getWalletAtom.wallet_info?.filter((customer)=> {
                return customer?.Customer_Id?.toString()?.indexOf(search?.toLowerCase()) >= 0 ||
                        customer?.Zoho_Customer_Id?.toString().toLowerCase()?.indexOf(search?.toLowerCase()) >= 0 ||
                        customer?.Customer_Full_Name?.toString().toLowerCase()?.indexOf(search?.toLowerCase()) >= 0 ||
                        customer?.Customer_Email_Address?.toString().toLowerCase()?.indexOf(search?.toLowerCase()) >= 0 
              });
              setUserList(tempResult);
        } else if(search.length < 1){
            setUserList(getWalletAtom.wallet_info);
        }
       
    }



  function handleRowClick(wallet){
    const id = wallet['Customer_Id'];
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`)
  }


    return (
        <>

            <div className="">
                <section className="">

                    {/* grid start */}
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-4 bg-gray-50 border border-gray-200 rounded-xl mt-5 mb-2">
                  <button
                    onClick={() => reloadData()}
                    className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    <RestartAlt fontSize="large" />
                    Reload
                  </button>

                  <input
                    onChange={(ev) => onSearchKeyChange(ev)}
                    className="w-full sm:w-80 px-4 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                    type="search"
                    placeholder="Search (ID, name, email)"
                    aria-label="Search"
                  />

                  <button className="px-4 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg hover:bg-gray-700 transition-colors">
                    Export
                  </button>
                </div>
                    {/* End of Grid */}

                 
                    
                        <section className="mt-5">
                                             <GeneralCustomTable
                                                  tableHeadList={columns} 
                                                  tableDataList={userList}
                                                 allowCheckBox={false} // show checkBox for each row
                                                 setSelectedRows={(sel)=> console.log(sel) }
                                                 rowKey={(record) => record.Customer_Id} // custom key
                                                 handleRowClick={handleRowClick} />
                         </section>

                </section>
            </div>

        </>

    );
}

export default WalletCheckPage;
